import React from "react";

// For user side pages
const HeartLoader: React.FC = () => {
  return (
    <div className="absolute top-0  w-full h-screen  flex items-center justify-center z-[30] backdrop-blur ">
      <img
        src={
          "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/gift-unscreen.gif"
        }
        alt="..Loading"
        className="w-[200px]"
      />
    </div>
  );
};

export default HeartLoader;
